import { Component, OnInit, ViewChild } from '@angular/core';
import { config } from '../config';
import { CommonService } from '../services/common/common.service';
import { HttpService } from '../services/http/http.service';
import { ToasterService } from '../services/toaster/toaster.service';
import { LogService } from '../services/log/log.service';
import { UiService } from '../services/uiloader/uiloader.service';
import { ThemeService } from '../services/theme/theme.service';

@Component({
  selector: 'app-company-settings',
  templateUrl: './company-settings.component.html',
  styleUrls: ['./company-settings.component.sass']
})
export class CompanySettingsComponent implements OnInit {

  constructor(private httpService: HttpService,
    private toasterService: ToasterService,
    private commonService: CommonService,
    private logService: LogService,
    private ui: UiService,
    private themeService: ThemeService) { }
    @ViewChild('editTemplates') editTemplates:any;
    @ViewChild('createTemplates') createTemplates:any;

    selectedFiles:any = {
      logo: null,
      dashboard: null,
      pdf: null
    };
    previewUrls:any = {
      logo: null,
      dashboard: null,
      pdf: null
    };
    selectedItem:string = '';
    customerData:any = {
      themecolour: '',
      secondarycolour: '',
      dashboard_image: '',
      pdf_image: ''
    };
    companyDetails$:any = {};
    imageLoading = false;
    
    allCompanies:any = [];

    selectedCompany:any = {id: 0, name: '', logo: '', dashboard_image: '', pdf_image: ''};

    // Color presets for quick selection
    primaryColorPresets = [
      '#0080F5', '#1976D2', '#2196F3', '#00BCD4', '#009688', 
      '#4CAF50', '#8BC34A', '#CDDC39', '#FFC107', '#FF9800',
      '#FF5722', '#F44336', '#E91E63', '#9C27B0', '#673AB7'
    ];

    secondaryColorPresets = [
      '#6C757D', '#495057', '#343A40', '#212529', '#868E96',
      '#ADB5BD', '#CED4DA', '#DEE2E6', '#E9ECEF', '#F8F9FA',
      '#78909C', '#607D8B', '#546E7A', '#455A64', '#37474F'
    ];

    originalThemeData:any = {
      themecolour: '',
      secondarycolour: '',
      dashboard_image: '',
      pdf_image: ''
    };

  ngOnInit(): void {
    const routes:any = [{
      name: 'Company Settings',
      path: 'company-settings'
    }];
    this.commonService.setHeaderData(routes);
  }

  onSelectCompany(company:any) {
    this.selectedCompany = company;
    this.customerData.themecolour = company.color_code || '';
    this.customerData.secondarycolour = company.secondary_color || '';
    this.customerData.dashboard_image = company.dashboard_image || '';
    this.customerData.pdf_image = company.pdf_image || '';
    
    // Store original data for change detection
    this.originalThemeData = {
      themecolour: company.color_code || '',
      secondarycolour: company.secondary_color || '',
      dashboard_image: company.dashboard_image || '',
      pdf_image: company.pdf_image || ''
    };
    
    // Reset selected files when switching companies
    this.selectedFiles = {
      logo: null,
      dashboard: null,
      pdf: null
    };
    // Reset preview URLs
    this.previewUrls = {
      logo: null,
      dashboard: null,
      pdf: null
    };
  }

  onTabChanged(event:any) {
    if(event.tab.textLabel == 'Template Setup' || event.tab.textLabel === 'Themes'){
      this.getCompanyList();
    }
  }
  getCompanyList() {
    const url = `${config.apiUrl}/companyadmin/getcompanies`;
    this.httpService.getCall(url).subscribe(result => {
      this.allCompanies = result;
      if (result.length > 0 && this.selectedCompany.id === 0) {
        this.onSelectCompany(result[0]);
      } else {
        const record = result.filter((item:any) => item.id === this.selectedCompany.id);
        this.onSelectCompany(record[0]);
      }
      this.ui.spin$.next(false);
    }, err => {
      this.toasterService.show('error', 'Error Occurred', 'Error occurred, Please try again');
    });
  }
   
  onAction(item:any) {
    this.customerData[this.selectedItem] = item.value;
    this.selectedItem = '';
    this.ui.spin$.next(false);
  }

  onItemSelect(val:string) {
    this.selectedItem = val;
  }

  uploadImage(fileInputEvent: any, imageType: string) {
    const file = fileInputEvent.target.files[0];
    if (file) {
      this.selectedFiles[imageType] = file;
      
      // Create preview URL for immediate display
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.previewUrls[imageType] = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }

  onSubmitTheme() {
    const formData = new FormData();
    
    // Add color data
    formData.append("color_code", this.customerData.themecolour || '');
    formData.append("secondary_color", this.customerData.secondarycolour || '');
    
    // Add image files if selected
    if (this.selectedFiles.logo) {
      formData.append("logo", this.selectedFiles.logo, `logo_${new Date().getTime()}.jpg`);
    }
    if (this.selectedFiles.dashboard) {
      formData.append("dashboard_image", this.selectedFiles.dashboard, `dashboard_${new Date().getTime()}.jpg`);
    } else if (this.customerData.dashboard_image) {
      // Pass existing dashboard image reference if no new file selected
      formData.append("dashboard_image", this.customerData.dashboard_image);
    }
    if (this.selectedFiles.pdf) {
      formData.append("pdf_image", this.selectedFiles.pdf, `pdf_${new Date().getTime()}.jpg`);
    } else if (this.customerData.pdf_image) {
      // Pass existing pdf header image reference if no new file selected
      formData.append("pdf_image", this.customerData.pdf_image);
    }

    this.imageLoading = true;
    this.ui.spin$.next(true);
    
    this.httpService.putCall(`${config.apiUrl}/companyadmin/updatecompany/${this.selectedCompany.id}`, formData).subscribe((data:any) => {
      // Apply theme colors immediately after successful update
      this.themeService.applyTheme(
        this.customerData.themecolour || '#0080F5',
        this.customerData.secondarycolour || '#6C757D'
      );
      
      // Reset selected files after successful upload
      this.selectedFiles = {
        logo: null,
        dashboard: null,
        pdf: null
      };
      
      // Reset preview URLs
      this.previewUrls = {
        logo: null,
        dashboard: null,
        pdf: null
      };
      
      this.imageLoading = false;
      this.ui.spin$.next(false);
      this.toasterService.show('success', 'Success', 'Theme configuration updated successfully');
      
      // Refresh company list to get updated data
      this.getCompanyList();
    },
    (err:any) => {
      this.imageLoading = false;
      this.ui.spin$.next(false);
      this.logService.logError(err);
      this.toasterService.show('error', 'Error', 'Failed to update theme configuration');
    });
  }

  onResetTheme() {
    // Reset to original company values
    this.customerData.themecolour = this.originalThemeData.themecolour;
    this.customerData.secondarycolour = this.originalThemeData.secondarycolour;
    this.customerData.dashboard_image = this.originalThemeData.dashboard_image;
    this.customerData.pdf_image = this.originalThemeData.pdf_image;
    this.selectedFiles = {
      logo: null,
      dashboard: null,
      pdf: null
    };
    this.previewUrls = {
      logo: null,
      dashboard: null,
      pdf: null
    };
    this.selectedItem = '';
    
    // Reset theme preview to original colors
    this.resetThemePreview();
  }

  getPreviewImage(imageType: string): string | null {
    // Return preview URL if file is selected, otherwise return existing company image
    if (this.previewUrls[imageType]) {
      return this.previewUrls[imageType];
    }
    
    switch (imageType) {
      case 'logo':
        return this.selectedCompany.logo || null;
      case 'dashboard':
        return this.selectedCompany.dashboard_image || null;
      case 'pdf':
        return this.selectedCompany.pdf_image || null;
      default:
        return null;
    }
  }

  onColorChange(colorType: string, event: any) {
    // Color change is handled by ngModel, this method can be used for additional logic
    console.log(`${colorType} color changed to:`, event.target.value);
    
    // Apply theme preview in real-time
    this.previewThemeChanges();
  }

  selectPresetColor(colorType: string, color: string) {
    if (colorType === 'primary') {
      this.customerData.themecolour = color;
    } else if (colorType === 'secondary') {
      this.customerData.secondarycolour = color;
    }
    
    // Apply theme preview in real-time
    this.previewThemeChanges();
  }

  hasChanges(): boolean {
    // Check if colors have changed
    const colorsChanged = this.customerData.themecolour !== this.originalThemeData.themecolour ||
                         this.customerData.secondarycolour !== this.originalThemeData.secondarycolour ||
                         this.customerData.dashboard_image !== this.originalThemeData.dashboard_image ||
                         this.customerData.pdf_image !== this.originalThemeData.pdf_image;
    
    // Check if any files are selected
    const filesSelected = this.selectedFiles.logo || this.selectedFiles.dashboard || this.selectedFiles.pdf;
    
    return colorsChanged || filesSelected;
  }

  /**
   * Preview theme changes in real-time without saving
   */
  previewThemeChanges() {
    const primaryColor = this.customerData.themecolour || '#0080F5';
    const secondaryColor = this.customerData.secondarycolour || '#6C757D';
    
    this.themeService.applyTheme(primaryColor, secondaryColor);
  }

  /**
   * Reset theme preview to original company colors
   */
  resetThemePreview() {
    const originalPrimary = this.originalThemeData.themecolour || '#0080F5';
    const originalSecondary = this.originalThemeData.secondarycolour || '#6C757D';
    
    this.themeService.applyTheme(originalPrimary, originalSecondary);
  }

  /**
   * Get current theme colors for display
   */
  getCurrentThemeColors() {
    return {
      primary: this.themeService.getCurrentPrimaryColor(),
      secondary: this.themeService.getCurrentSecondaryColor()
    };
  }

}
